import { Link } from 'react-router-dom';

export default function HeroSection() {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20modern%20abstract%20digital%20entertainment%20background%20with%20flowing%20gradient%20waves%20in%20warm%20coral%20orange%20and%20soft%20amber%20tones%2C%20smooth%20curved%20shapes%2C%20minimalist%20clean%20composition%2C%20bright%20and%20energetic%20vibe%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=mogu-hero-bg&orientation=landscape"
          alt="蘑菇视频背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full container-page flex flex-col items-center text-center py-20 md:py-24">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
          <i className="ri-sparkling-line text-white text-sm"></i>
          <span className="text-white/90 text-sm font-medium">2026最新版本 v5.2.0</span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white font-heading max-w-3xl leading-tight mb-6">
          发现精彩，记录生活
        </h1>
        <p className="text-lg md:text-xl text-white/80 max-w-2xl mb-10 leading-relaxed">
          蘑菇视频 —— 海量高清短视频内容平台，流畅播放体验，丰富创作工具，千万用户的选择
        </p>

        <div className="flex flex-col sm:flex-row gap-4 mb-12">
          <button
            onClick={() => scrollToSection('download-section')}
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-download-cloud-2-line mr-2"></i>
            立即下载
          </button>
          <Link
            to="/category/tutorial"
            className="px-8 py-3.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-semibold rounded-full text-base border border-white/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line mr-2"></i>
            使用教程
          </Link>
        </div>

        <div className="grid grid-cols-3 gap-8 md:gap-16">
          {[
            { value: '5000万+', label: '活跃用户' },
            { value: '100万+', label: '内容创作者' },
            { value: '4.8', label: '用户评分' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white font-heading">{stat.value}</div>
              <div className="text-sm text-white/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-white/60"></i>
      </div>
    </section>
  );
}